import Script from 'next/script';
import { Page } from '@thisisdevelopment/heritage-core-library';
import styled from 'styled-components';
import theme from 'theme';
import Head from 'next/head';

const IFrame = styled.iframe`
  @media ${theme.mediaQuery.mobile} {
    min-height: 700px;
  }
  min-height: 550px;
`;

const TermsAndConditions = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 40px;

  a {
    color: ${({ theme }) => theme.colors.brandGold};
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 600;
  }
`;

const NestedParagraph = styled.span`
  display: block;
  margin-bottom: 20px;
`;

export default function PrizeDraw() {
  return (
    <>
      <Head>
        <title>Dulux Heritage Prize Draw</title>
      </Head>
      <Page
        title="The Dulux Heritage Winter Bundle competition is now finished."
        headline={
          <>
            <NestedParagraph>Don’t miss out on future competitions.</NestedParagraph>
            <NestedParagraph>
              Sign up to our newsletters and be the first to hear about the latest news, colour
              inspiration and new competitions.
            </NestedParagraph>
          </>
        }
      >
        <Script
          id="munchkin"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: `
               (function() {
    var didInit = false;
    function initMunchkin() {
      if(didInit === false) {
        didInit = true;
        Munchkin.init('126-DNG-032', {"wsInfo":"j0hRdtjOKwEN"});
      }
    }
    var s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = '//munchkin.marketo.net/munchkin.js';
    s.onreadystatechange = function() {
      if (this.readyState == 'complete' || this.readyState == 'loaded') {
        initMunchkin();
      }
    };
    s.onload = initMunchkin;
    document.getElementsByTagName('head')[0].appendChild(s);
  })();
        `,
          }}
        ></Script>
        <IFrame
          src="https://lp.akz.no/UKI-CF-2024-10-Heritage-Deco-Capture_Landinpage.html"
          width="100%"
          loading="lazy"
          style={{ border: 0, paddingTop: '40px' }}
          allowFullScreen
          aria-hidden="false"
          tabIndex={0}
        ></IFrame>
        <TermsAndConditions>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.duluxtradepaintexpert.co.uk/en/terms#HeritageBundle"
          >
            *Prize Draw Terms and Conditions
          </a>
        </TermsAndConditions>
      </Page>
    </>
  );
}
